import type { ReactNode } from 'react'
import { create } from 'zustand'
import { combine, devtools } from 'zustand/middleware'

export interface DeleteConfirmationProps {
  title: string
  description: ReactNode
  deleteText?: string
  onConfirm: () => void
}

export const useDeleteConfirmationStore = create(
  devtools(
    combine(
      {
        isOpen: false,
        title: '',
        description: '' as ReactNode,
        deleteText: 'Delete',
        onConfirm: () => {},
      },
      (set) => ({
        open: ({
          title,
          description,
          deleteText = 'Delete',
          onConfirm,
        }: DeleteConfirmationProps) =>
          set({
            isOpen: true,
            title,
            description,
            deleteText,
            onConfirm,
          }),
        setIsOpen: (isOpen: boolean) => set({ isOpen }),
      })
    )
  )
)
